import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const theHive = defineConnector({
  identifier: "theHive",
  name: "TheHive",
  tagLine: "Security incident response",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: ({ baseUrl }) => domainToRegex(baseUrl),
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Get your TheHive API key",
      items: [
        {
          kind: "markdown",
          content: `
1. Log in to your TheHive instance
2. Navigate to your user profile (click your username in the top right)
3. Go to the **API Keys** section
4. Click **Create API Key**
5. Give it a descriptive name and copy the generated API key
`,
        },
      ],
    },
    {
      title: "Enter your TheHive details",
      items: [
        {
          kind: "url",
          label: "TheHive instance URL",
          target: { kind: "configuration", field: "baseUrl" },
          placeholder: "https://thehive.example.com",
        },
        {
          kind: "input",
          label: "API key",
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ baseUrl }) => `${baseUrl}/api/v1/status`,
  },
});
